import React, { useState, useEffect, useContext } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import ErrorBoundary from 'components/Letters/Single/Train/ErrorBoundary';
import Filters from './Filters';
import Collapses from './Collapses';
import api from 'services';
import Size from './Size';
import { addNotification } from 'actions/notifications/notifications';
import Composition from './Composition';
import Pagination from 'components/Libs/Pagination';

const rowsPerPage = [50, 100];

const urlParams = new URLSearchParams(window.location.search);
const defaultFilters = {
    /**@returns {FiltersState} */
    get: () => ({ 
        vessel: urlParams.has('_id') ? {
            _id: urlParams.get('_id'),
            name: urlParams.get('name'),
        } : {},
        emailId: urlParams.get('emailId') || '',
        approved: null,
        params: [],
    }),
};

const PageContext = React.createContext(1);

function VesselsCompositionMain({ addNotification }) {
    /**
     * @namespace {Object}
     * @property {FiltersState} 
     * @property {FiltersStateSetter} 
     */
    const [filters, setFilters] = useState(defaultFilters.get);

    /**  @type {[ LeftSide, LeftSideSetter ]} LeftSide */
    const [leftSide, setLeftSide] = useState('vesselsList');

    /** @type {[ RightSide, RightSideSetter ]} RightSide */
    const [rightSide, setRightSide] = useState(null);
    const [sizes, setSizes] = useState(null);
    const [modifySizes, setModifySizes] = useState(null);
    const [forMultiTransfer, setForMultiTransfer] = useState([]);
    const [loading, setLoading] = useState(false);
    const [initialLoaded, setInitialLoaded] = useState(false);
    const [page, setPage] = useState(1);
    const [sizesCounters, setSizesCounters] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [numberOfRows, setNumberOfRows] = useState(50);

    function getCounters() {
        api.getVesselsCompositions({ ...filters, page, limit: numberOfRows })
            .then((response) => {
                if (response.errors && response.errors.length) {
                    addNotification({
                        title: 'Error',
                        message: response.errors[0].messages,
                        level: 'error',
                        _id: new Date().getMilliseconds(),
                        autoDismiss: 3, 
                    });
                }
                if (response.data) {
                    const { data } = response;
                    if (initialLoaded) {
                        setSizesCounters(data.sizes);
                    } else {
                        setInitialLoaded(true);
                        setSizesCounters(data.sizes);
                    }
                    setTotalPages(data.total);
                }
            });
    }
    
    const selectVessel = (vessel) => {
        setLeftSide('vessel');
        // setPage(1);
        setInitialLoaded(false);
        setFilters(f => ({ ...f, vessel: _.pick(vessel, ['_id', 'name']) }));
    };

    const addToMultiTransfer = (obj) => {
        setForMultiTransfer(s => [...s, obj]);
    };

    function getSizes() {
        setForMultiTransfer([]);
        setLoading(true);

        if (leftSide === 'vessel') {
            if (
                (!filters.vessel._id && !filters.emailId) ||
                !filters.vessel._id
            ) {
                setLeftSide('vesselsList');
                getCounters();
                return;
            }
        } else {
            setLeftSide('vesselsList');
            if (page === 1) {
                getCounters();
                return;
            }
        }

        api.getEmailsForVesselComposition({ ...filters, page })
            .then(async (response) => {
                if (response.errors && response.errors.length) {
                    addNotification({
                        title: 'Error',
                        message: response.errors[0].messages,
                        level: 'error',
                        _id: new Date().getMilliseconds(),
                        autoDismiss: 3, 
                    });
                }
                if (response.data) {
                    setSizes(response.data);
                }
                await setTimeout(() => {
                    setRightSide('vessel');
                    setLoading(false);
                }, 50);
            });
    }

    useEffect(() => {
        setRightSide(null);
        setSizes(null);
        getSizes();
    }, [filters]);

    useEffect(() => {
        if (initialLoaded) {
            getCounters();
        }
    }, [page]);

    const reloadSizes = () => {
        setLeftSide(null);
        setSizesCounters([]);
        setInitialLoaded(false);
        setPage(1);
        // crazy, isn't it?
        setFilters(f => ({ ...f, vessel: Object.assign({}, filters.vessel) }));
    };

    /**
     * @param {string | null} emailId 
     */
    const setEmailIdFilter = (emailId) => {
        setLeftSide(null);
        setSizesCounters([]);
        setInitialLoaded(false);
        setPage(1);
        setFilters(f => ({ ...f, emailId }));
    };

    const setApprovedFilter = (approved) => {
        setLeftSide(null);
        setSizesCounters([]);
        setInitialLoaded(false);
        setPage(1);
        setFilters(f => ({ ...f, approved }));
    };

    const clearVesselFilter = () => {
        if (!filters.vessel._id) {
            return;
        }
        selectVessel({});
    };

    const setParamsFilter = (params) => {
        setLeftSide(null);
        setSizesCounters([]);
        setInitialLoaded(false);
        setPage(1);
        setFilters(f => ({ ...f, params }));
    };

    const handleUpdateRow = ({ page: p, numberOfRows: n }) => {
        setPage(p);
        setNumberOfRows(n);
    };

    return (
        <div className='single-letter'>
            <div className='content' style={{ width: '53vw', height: 'calc(100vh - 65px)', overflowY: 'auto' }}>
                <div className='management'>
                    <Filters 
                        selectVessel={selectVessel}
                        filters={filters}
                        setModifySizes={setModifySizes}
                        forMultiTransfer={forMultiTransfer}
                        reloadSizes={reloadSizes}
                        setEmailIdFilter={setEmailIdFilter}
                        clearVesselFilter={clearVesselFilter}
                        setApprovedFilter={setApprovedFilter}
                        setParamsFilter={setParamsFilter}
                    />
                </div>
                {
                    !loading && !sizes &&
                    <div id='sizes__empty'>
                        Sizes not found!
                    </div>
                }
                {
                    leftSide === 'vesselsList' ? 
                        <React.Fragment>
                            <Composition 
                                filters={filters}
                                selectSize={selectVessel}
                                sizesCounters={sizesCounters}
                            />
                            {/* {
                                renderPagination
                            } */}
                            <PageContext.Provider value={page}>
                                <Paginator 
                                    totalPages={totalPages}
                                    // page={page}
                                    numberOfRows={numberOfRows}
                                    handleUpdateRow={handleUpdateRow}
                                />
                            </PageContext.Provider> 
                        </React.Fragment>
                        :
                        sizes && 
                        <ErrorBoundary>
                            <Collapses 
                                sizes={sizes}
                                vessel={filters.vessel}
                                getSizes={getSizes}
                                setModifySizes={setModifySizes}
                                addToMultiTransfer={addToMultiTransfer}
                                shouldGenerateCollapses={leftSide === 'vessel'}
                                shouldShowApproveReject={!filters.approved}
                            />
                        </ErrorBoundary>
                }
                {
                    filters.emailId && sizes && sizes.emailData &&
                    <div className='filter-column paper-block'>
                        <div className='name-block absolute small-name'>Email</div>
                        <p style={{ fontSize: '13px' }}><b>Subject:</b> {sizes.emailData.subject}</p>
                        <p style={{ whiteSpace: 'pre-line' }}>
                            { sizes.emailData.text }
                        </p>
                    </div>
                }
            </div>
            <div className='sidebar' style={{ width: '47vw' }}>
                {
                    rightSide === 'vessel' && 
                    <ErrorBoundary>
                        <Size
                            vesselId={filters.vessel._id}
                            modifySizes={modifySizes}
                        />
                    </ErrorBoundary>
                }
            </div>
        </div>
    );
}

export default connect(
    null,
    dispatch => bindActionCreators(
        {
            addNotification,
        },
        dispatch,
    ),
)(VesselsCompositionMain);

function Paginator({
    totalPages, numberOfRows, handleUpdateRow,
}) {
    const page = useContext(PageContext);

    return (
        <Pagination
            total={totalPages}
            rowsPerPage={rowsPerPage}
            page={page}
            numberOfRows={numberOfRows}
            updateRows={e => handleUpdateRow(e)}
        />
    );
}

/**
 * @typedef {null | 'vessel' | 'vesselsList'} LeftSide 
 * @typedef {Function} LeftSideSetter
 * 
 * @typedef {null | 'vessel'} RightSide 
 * @typedef {Function} RightSideSetter
 * 
 * @typedef {{ 
 *      vessel: { _id?: string, name?: string },
 *      emailId?: string,
 *      approved: boolean,
 *      params: [string?]
 * }} FiltersState
 * 
 * @callback FiltersStateSetter
 * @param {FiltersState} state
 * @returns {void}
 */



// WEBPACK FOOTER //
// ./app/components/Vessels/Composition/Main.jsx